import { useCallback, useRef, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import { calculateMinPriceQuery } from "../queries";

export const isDateInPast = (dateString) => {
  if (!dateString) return false;
  const inputDate = new Date(dateString);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  inputDate.setHours(0, 0, 0, 0);
  return inputDate < today;
};

export function useBookingPriceData(rvId) {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const fetchRef = useRef();

  const [fetchCalculateMinPrice] = useLazyQuery(
    calculateMinPriceQuery,
    {
      fetchPolicy: "no-cache",
      onCompleted: (response) => {
        setLoading(false);
        const price = response?.calculate_min_price?.price;
        const price_per_night = response?.calculate_min_price?.price_per_night;
        const nights = response?.calculate_min_price?.nights;
        const old_price = response?.calculate_min_price?.old_price;
        const priceForm = response?.calculate_min_price?.price_form;
        setData({
          price,
          price_per_night,
          nights,
          old_price,
          priceForm
        });
      }
    }
  );

  const calculatePrice = useCallback(({
    departure_date,
    return_date,
    rental_type,
    ...rest
  } = {}) => {
    if (!rvId) return;
    setLoading(true);
    fetchRef.current = { rvId: Number(rvId) };
    fetchCalculateMinPrice({
      variables: {
        rv: Number(rvId),
        rental_type: rental_type || 1,
        ...((departure_date !== undefined && departure_date !== "Invalid date" && !isDateInPast(departure_date)) && { departure_date }),
        ...((return_date !== undefined && return_date !== "Invalid date" && !isDateInPast(departure_date)) && { return_date }),
        ...rest
      }
    });
  }, [fetchCalculateMinPrice, rvId]);

  const clearPriceData = useCallback(() => {
    setData({});
    setLoading(false);
  }, []);

  return {
    ...data,
    loading,
    calculatePrice,
    clearPriceData
  };
};
